import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IMVChecklistTable } from 'src/components/Conduct/IMVChecklist/IMVChecklistTable';
import IMVChecklistPage from 'src/components/Conduct/IMVChecklist/IMVChecklistPage';

const initialState: any = {
  showCMPArr: [
    {
      cmp: IMVChecklistTable,
      key: 'IMVChecklistTable',
      curruntlyActive: true
    },
    {
      cmp: IMVChecklistPage,
      key: 'IMVChecklistPage',
      curruntlyActive: false
    }
  ],
  selectedRowData: {}
};

export const imvChecklist = createSlice({
  name: 'imvChecklist',
  initialState,
  reducers: {
    setShowIMVchecklistCMPArr: (state: any, action: PayloadAction<string>) => {
      const tempBackArr = state.showCMPArr.map((ele: any) => {
        if (ele.key === action.payload) {
          return { ...ele, curruntlyActive: true };
        }
        return { ...ele, curruntlyActive: false };
      });
      state.showCMPArr = tempBackArr;
    },
    setSelectedIMVChecklistData: (state: any, action: any) => {
      state.selectedRowData = action.payload;
    }
  }
});

export const { setShowIMVchecklistCMPArr, setSelectedIMVChecklistData } = imvChecklist.actions;
